import { routes } from '../routes';

// Where an elementary or sport order package goes once it is in the cart: the
// add-ons page when the school has elementary add-ons to offer, else review.
//
// ONE implementation, shared by the package builder and the group picture page
// (SportsTeamPicture). The page used to go straight to review, so a sport
// parent buying a team or buddy picture never saw the add-ons (2026-10-13).
//
// `insteadOfReview` is where a package goes when there is NOTHING TO REVIEW.
// A sport team or buddy picture is one fixed photograph: no pose to place, no
// background to choose (it is a Phase 1.5 JPG that already carries its own),
// so the review screen showed a lone thumbnail and an Edit that could not
// change anything, between the parent and checkout (Katie, 2026-10-14).
// Callers pass review's OWN next destination (hooks/useAfterReviewRoute), so
// skipping the page lands exactly where pressing Continue on it would have --
// promo page included. Omitted (or null, while that question is still
// unanswered), the review page stays the destination.
export default function afterAddRoute({
  hasAddons, favorites, orderPackageId, optionId, packageId, insteadOfReview = null,
}) {
  if (!hasAddons) return insteadOfReview || routes.multiPoseReview(orderPackageId);

  return routes.multiPoseAddons({
    favs: favorites, op: orderPackageId, opt: optionId, package: packageId, isSenior: false,
  });
}
